import { Modal, Typography } from 'antd'
import Button from 'components/button/Button'
import { IconCancel } from 'components/icons'

interface IProps {
  isOpen: boolean
  setModal: (value: boolean) => void
  onClick: () => void
  loading: boolean
}

const ModalInvoiceConfirmation = (props: IProps) => {
  const { isOpen, setModal, onClick, loading } = props

  return (
    <Modal
      data-testid="modal_invoice_confirm"
      open={isOpen}
      footer={null}
      onCancel={() => setModal(false)}
      closeIcon={<IconCancel strokeWidth="2" color="black" />}
    >
      <Typography.Paragraph className="text-lg text-[#364152] font-semibold">
        Apakah Anda yakin ingin konfirmasi pembayaran ini?
      </Typography.Paragraph>
      <div className="flex mt-4">
        <Button
          block={true}
          onClick={() => setModal(false)}
          data-testid="btn_cancel"
          className="inline-block mr-4 font-bold uppercase text-primary"
          label="Batalkan"
        />
        <Button
          disabled={false}
          loading={loading}
          block={true}
          onClick={onClick}
          data-testid="btn_accept"
          className="inline-block font-bold uppercase"
          iconPosition="right"
          label="konfirmasi"
          variant="solid-primary"
        />
      </div>
    </Modal>
  )
}

export default ModalInvoiceConfirmation
